import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';

function ProjectCard({data}) {
  return (
    <PCard layout >
        <a href={data.link}  ><div className="img-cont">
            <img src={data.photo} alt={data.name} />
        </div></a>
        <p className=' proj-name' >{data.name}</p>
        <p className='justify proj-desc ' >{data.desc}</p>
    </PCard>
  );
}

const PCard = styled(motion.div)`
    border-radius: 10px;
    box-shadow: 6px 13px 15px -10px #383e3f62;
    padding: 0.5rem;
    
    .proj-name{
        color: var(--primary);
        font-size: 1.3rem;
        font-weight: bold;
        letter-spacing: 0.1em;
    }
    .proj-desc{
        color: var(--tertiary);
    }
    .proj-desc, .proj-name{
        margin: 1rem 1.3rem;
    }
    .img-cont{
        cursor: pointer;
        overflow: hidden;
        border-radius: 10px 10px 0px 0px;
        height: 30vh;
    }
    img{
        object-fit: cover;
        width: 100%;
        height: 100%;
        transition: all 0.5s ease-out;
    }

    img:hover{
        transform: scale(1.04);
    }

`

export default ProjectCard;